import { createSlice } from "@reduxjs/toolkit";
import { demographicCategories, turnoutScores } from "../pages/district/config";

const initialState = {
  scores: {
    selected: "partisan",
  },
  turnoutScores: {
    score: "presidential_general_turnout",
    demographic: "ethnicity",
  },
  demographicFilters: {
    age: [],
    ethnicity: [],
    education: [],
    gender: [],
  },
  contextBar: {
    visibleSection: null,
  },
  selectedTab: "Demographics",
  districtName: null,
  districtRegisteredVoters: null,
  comparisonName: null,
  comparisonRegisteredVoters: null,
  earlyVoteComparison: "No Comparison",
  earlyVoteVoteType: "total",
};

const districtPageSlice = createSlice({
  name: "districtPage",
  initialState,
  reducers: {
    // No allowlist. The Scores dropdown is built from /api/metrics, so the API is the authority
    // on what exists; re-checking against a hardcoded list here would silently reject the scores
    // that list was missing -- ideology_conservative among them -- and leave the picker looking
    // broken rather than the state wrong.
    toggleSelectedScore: (state, action) => {
      const { score } = action.payload;
      if (typeof score === "string" && score) {
        state.scores.selected = score;
      }
    },
    toggleTurnoutScore: (state, action) => {
      const { score } = action.payload;
      if (turnoutScores.includes(score)) {
        state.turnoutScores.score = score;
      }
    },
    toggleTurnoutDemographic: (state, action) => {
      const { demographic } = action.payload;
      if (
        demographicCategories.includes(demographic) &&
        demographic !== "education" &&
        demographic !== "income"
      ) {
        state.turnoutScores.demographic = demographic;
      }
    },
    toggleDemographicFilter: (state, action) => {
      const { category, value } = action.payload;
      // Categories come from /api/config/filters, which may offer one this slice has no bucket for.
      // Indexing a missing key threw before; create it instead.
      if (!state.demographicFilters[category]) {
        state.demographicFilters[category] = [];
      }
      if (state.demographicFilters[category].includes(value)) {
        state.demographicFilters[category] = state.demographicFilters[
          category
        ].filter((item) => item !== value);
      } else {
        state.demographicFilters[category].push(value);
      }
    },
    setContextBarVisibleSection: (state, action) => {
      state.contextBar.visibleSection = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setDistrictName: (state, action) => {
      state.districtName = action.payload;
    },
    setDistrictRegisteredVoters: (state, action) => {
      state.districtRegisteredVoters = action.payload;
    },
    setComparisonName: (state, action) => {
      state.comparisonName = action.payload;
    },
    setComparisonRegisteredVoters: (state, action) => {
      state.comparisonRegisteredVoters = action.payload;
    },
    setEarlyVoteComparison: (state, action) => {
      state.earlyVoteComparison = action.payload;
    },
    setEarlyVoteVoteType: (state, action) => {
      state.earlyVoteVoteType = action.payload;
    },
  },
});

export const {
  toggleSelectedScore,
  toggleTurnoutScore,
  toggleTurnoutDemographic,
  toggleDemographicFilter,
  setContextBarVisibleSection,
  setSelectedTab,
  setDistrictName,
  setDistrictRegisteredVoters,
  setComparisonName,
  setComparisonRegisteredVoters,
  setEarlyVoteComparison,
  setEarlyVoteVoteType,
} = districtPageSlice.actions;

export default districtPageSlice.reducer;
